import type { VariablesOf } from "gql.tada";
import { GetProductState } from "api/queries/product";
import { isUUID } from "utils/validators/isUUID";
import { gqlFetchWithAuth } from "utils/fetchData/gqlFetchWithAuth";
import type { RunActionReturn } from "../productActions";
import { parseErrorMessage } from "./sync";
import type { FetchError } from "utils/fetchData/types";

export type GetProductStateVariables = VariablesOf<
  typeof GetProductState
>["input"];

export const load = async (
  variables: GetProductStateVariables,
): RunActionReturn => {
  if (!isUUID(variables.nodeId)) {
    throw new Error("Invalid node ID");
  }
  let data;
  try {
    data = await gqlFetchWithAuth({
      query: GetProductState,
      variables: {
        input: variables,
      },
    });
    parseErrorMessage(data);
  } catch (err) {
    const error = err as FetchError | Error;
    parseErrorMessage(error);
    throw err;
  }
  if (!data || !data.getProductState || !data.getProductState.result) {
    throw new Error("Product fetch error: Invalid response structure");
  }
  if (data.getProductState.errorMessage) {
    throw new Error(
      `Product fetch error: ${data.getProductState.errorMessage}`,
    );
  }
  if (!data.getProductState.result.product) {
    throw new Error("Product fetch error: Product data is missing");
  }
  const output = data.getProductState.result;
  return { output, hasChanged: false, nodeId: variables.nodeId };
};
